$(document).ready(function(){
  $(".link-display").click(function(event) {
    //       Select the body of the page and scroll down by 650 pixels worth
    // $("html, body").animate({ scrollTop: $("#shopify-section-template--16215546364091__69015850-6d26-4a4a-9a87-c28f6b270d2d").offset().top }, 800);
    $("html, body").animate({ scrollTop: 1150 }, 800);
    
  });
})

// 
$('.scrollTo').click(function(){
    $('html, body').animate({
        scrollTop: $( $(this).attr('href') ).offset().top
    }, 500);
    return false;
});